var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooBigGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graph Decor Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5692",
    d: "M35.7382 30.1973H18.2602C17.8625 30.2561 17.5033 30.4674 17.2585 30.7863C17.0137 31.1053 16.9026 31.507 16.9487 31.9064V64.0012H37.0497V31.9064C37.095 31.5071 36.9835 31.1059 36.7389 30.7871C36.4943 30.4683 36.1355 30.2569 35.7382 30.1973Z",
    fill: "#8F9AAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5693",
    d: "M37.4288 8.79156L31.2546 7.81538L28.5554 1.76225C28.4106 1.47444 28.1871 1.23359 27.911 1.06764C27.6348 0.901682 27.3173 0.817427 26.9952 0.824647C26.7044 0.830856 26.4215 0.919973 26.1797 1.08152C25.9378 1.24306 25.7471 1.47031 25.6301 1.73653L22.8033 7.68251L16.6291 8.49367C16.3276 8.53217 16.0428 8.65447 15.8073 8.84667C15.5718 9.03887 15.3948 9.29327 15.2966 9.58098C15.1984 9.86869 15.1829 10.1782 15.2517 10.4743C15.3206 10.7704 15.4711 11.0412 15.6862 11.2561L20.1052 15.6751L18.9672 21.8161C18.91 22.1156 18.938 22.4251 19.048 22.7094C19.158 22.9937 19.3456 23.2414 19.5894 23.4244C19.8332 23.6074 20.1235 23.7182 20.4272 23.7444C20.731 23.7706 21.0359 23.711 21.3075 23.5724L26.8645 20.7457L26.9931 20.81L32.3561 23.7031C32.6197 23.8505 32.9194 23.9206 33.221 23.9055C33.5226 23.8903 33.8138 23.7905 34.0613 23.6175C34.3088 23.4445 34.5026 23.2053 34.6204 22.9272C34.7382 22.6492 34.7753 22.3436 34.7274 22.0455L33.7513 15.8712L38.2678 11.5476C38.4928 11.3451 38.6554 11.0826 38.7365 10.791C38.8176 10.4994 38.8138 10.1907 38.7256 9.90112C38.6374 9.61157 38.4684 9.35317 38.2386 9.15626C38.0087 8.95935 37.7274 8.83209 37.4277 8.78941L37.4288 8.79156Z",
    fill: "url(#paint0_linear_4730_51992)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5696",
    d: "M12.0624 41.4238H2.27489C1.87716 41.4827 1.51791 41.6939 1.27314 42.0129C1.02837 42.3319 0.917261 42.7335 0.963326 43.1329V64.0001H13.3761V43.1329C13.4218 42.7333 13.3103 42.3314 13.0651 42.0125C12.82 41.6935 12.4604 41.4824 12.0624 41.4238Z",
    fill: "#8F9AAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5697",
    d: "M51.7246 45.166H41.935C41.5374 45.2251 41.1785 45.4365 40.9339 45.7554C40.6893 46.0743 40.5784 46.4759 40.6245 46.8751V63.9983H53.0361V46.8751C53.0817 46.4758 52.9703 46.0744 52.7257 45.7556C52.481 45.4367 52.1221 45.2254 51.7246 45.166Z",
    fill: "#8F9AAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4730_51992",
    x1: 27.002,
    y1: 0.824219,
    x2: 27.002,
    y2: 23.9075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7032C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5136D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooBigGraphIcon);
export default __webpack_public_path__ + "static/media/tooBigGraphIcon.7d26c2b3fcb24bd24f91915fdc54720a.svg";
export { ForwardRef as ReactComponent };